export var FilterItemType;
(function (FilterItemType) {
    FilterItemType["Input"] = "input";
    FilterItemType["Select"] = "select";
    FilterItemType["Multiselect"] = "multiselect";
    FilterItemType["Checkbox"] = "checkbox";
    FilterItemType["Custom"] = "custom";
})(FilterItemType || (FilterItemType = {}));
